import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({
  baseURL: API_BASE,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default client;

// Auth
export const login = (email: string, password: string) =>
  client.post('/auth/login', { email, password });

export const register = (data: any) =>
  client.post('/auth/register', data);

export const getMe = () => client.get('/auth/me');

// Dashboard
export const getDashboard = () => client.get('/dashboard/');

export const getManagerDetail = (id: number) =>
  client.get(`/dashboard/manager/${id}`);

export const getDialogueDetail = (id: number) =>
  client.get(`/dashboard/dialogue/${id}`);

export const getAnalytics = (days: number = 30) =>
  client.get(`/dashboard/analytics?days=${days}`);
